<template>
  <div v-if="obra" class="mt-2">
    <v-row :class="{ 'flex-column-reverse': vuetify?.breakpoint.smAndDown }">
      <v-col cols="12">
        <v-row dense>
          <Info
            v-if="obra.cdObraColecaoPeriodico"
            cols="12"
            link
            label="Localização"
            :value="obra.deLocalizacao"
          >
            <div>
              <router-link
                :to="getPathLocalizacao(obra.cdObraColecaoPeriodico[0])"
              >
                {{ obra.deLocalizacao }}
              </router-link>
            </div>
            <div>
              <router-link
                v-if="obra.deLocalizacao2"
                :to="getPathLocalizacao(obra.cdObraColecaoPeriodico[1])"
              >
                {{ obra.deLocalizacao2 }}
              </router-link>
            </div>
          </Info>

          <Info
            cols="6"
            label="Título do periódico"
            :value="obra.deTituloColecaoPeriodico"
          />
          <Info cols="6" label="Documento" :value="obra.deDocumento" />
          <Info cols="6" label="Autor(es)" :value="obra.autorList" />
          <Info cols="12" label="Título" :value="obra.deTituloSubtitulo" />
          <Info cols="6" label="Paginação" :value="obra.dePaginacao" />
          <Info cols="6" label="Sigla" :value="obra.deSigla" />

          <template v-if="possuiPublicacao">
            <Info
              cols="6"
              label="Local"
              :value="(obra.obraEditoraList ?? [])[0].local"
            />
            <Info
              cols="6"
              label="Casa publicadora"
              :value="(obra.obraEditoraList ?? [])[0].nmEditora"
            />
          </template>

          <Info cols="6" label="Mês" :value="obra.deMes" />

          <template v-if="possuiPublicacao">
            <Info
              cols="6"
              label="Ano"
              :value="(obra.obraEditoraList ?? [])[0].anoPublicacao"
            />
          </template>

          <Info cols="6" label="Volume" :value="obra.deVolume" />

          <Info cols="6" label="Número" :value="obra.deNumero" />

          <Info cols="6" label="Idioma(s)" :value="obra.idiomaList" />

          <Info cols="12" label="Nota(s)" :value="obra.notaList" />

          <Info
            cols="12"
            label="Disponibilidade"
            :value="obra.deDisponibilidade"
          />

          <Info v-if="obra.deSite" cols="12" label="Disponível em">
            <a :href="obra.deSite" target="_blank" v-text="obra.deSite" />
          </Info>
        </v-row>
      </v-col>
    </v-row>
    <v-row dense>
      <Info cols="12" highlighted header="Assunto(s)" :value="obra.assuntos" />
    </v-row>
  </div>
</template>

<script setup lang="ts">
import Info from '@/components/DynamicInfo.vue';
import { ConsultaObrasStore } from '../../store/ConsultaObrasStore';
import { storeToRefs } from 'pinia';
import { useVuetify } from '@/composables/useVuetify';
import { TipoObra } from '@/constants';
import { computed } from 'vue';

const vuetify = useVuetify();
const store = ConsultaObrasStore();
const { obraTempImpressao: obra } = storeToRefs(store);

const possuiPublicacao = computed(() => obra.value?.obraEditoraList?.length);

const getPathLocalizacao = (cdObraColecaoPeriodico: number) => {
  return {
    path: `/obras/visualiza/${cdObraColecaoPeriodico}/${TipoObra.COLECAO_PERIODICO}`,
    query: { back: 'true' },
  };
};
</script>
